export const SOCKET_CONFIG = {
  CONNECTION_TIMEOUT: 30000, // 30 seconds
  RECONNECT_DELAY: 5000, // 5 seconds
  MAX_RECONNECT_ATTEMPTS: 3,
  HEARTBEAT_INTERVAL: 25000, // 25 seconds
};

export const AUTHORIZATION_EVENTS = {
  TOKEN_RECEIVED: 'TOKEN_RECEIVED',
  ACCESS_GRANTED: 'ACCESS_GRANTED',
  ACCESS_DENIED: 'ACCESS_DENIED',
  SESSION_AUTHORIZED: 'SESSION_AUTHORIZED',
};
